import { Component, Input } from '@angular/core';
import { UiService } from '../../../../../core/services/core.ui.service';
import { SettingService } from '../../../../../core/services/core.setting.service';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-auto-close-toggle',
  template: require('./trackeritem.auto.close.toggle.component.html')
})
export class TrackerItemAutoCloseToggleComponent {
  @Input() trackeritem: any;
  @Input() tracker: any;
  @Input() acls: any;

  autoClose: number | undefined;
  autoCloseSaving: boolean;
  useAutoclose: boolean;

  constructor(private uiService: UiService, private settingService: SettingService) { }

  ngOnInit() {
    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  toggleAutoclose() {
    if (this.autoClose === undefined) {
      return;
    }

    this.autoCloseSaving = true;
    const currentValue = Number(this.autoClose);
    const nextValue = currentValue === 1 ? 0 : 1;
    this.autoClose = nextValue;

    this.settingService.post({ settingName: 'autoclose', section: 'trackeritem', refId: this.trackeritem.id, settingValue: this.autoClose })
      .then(response => {
        this.autoCloseSaving = false;
        this.uiService.message.showSuccess('Autoclose ' + (this.autoClose == 1 ? 'Enabled' : 'Disabled'));
      })
      .catch(response => {
        this.autoCloseSaving = false;
        this.autoClose = currentValue;
        this.uiService.message.showError(response, 'Failed to set autoclose');
      });
  }

  autocloseTitle() {
    if (this.autoClose === undefined) {
      return '';
    }

    return this.autoClose === 1 ? 'Autoclose is enabled. Click to disable.' : 'Autoclose is disabled. Click to enable';
  }

  private init() {
    if (_.get(this.tracker,'settings.autoClose.setting',0) > 0 && this.tracker.trackerType == 3) {
      this.useAutoclose = true;
      this.autoClose = undefined;

      this.settingService.fetch('trackeritem', this.trackeritem.id, 'autoclose', "1")
        .then((response: any) => {
          const numericValue = Number(response.settingValue);
          this.autoClose = isNaN(numericValue) ? 0 : numericValue;
        })
        .catch(response => {
          this.autoClose = 0;
        });
    }
  }
}
